<nav aria-label="breadcrumb" *ngIf="breadcrumb.length">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" [ngClass]="{active: i === breadcrumb.length - 1}" *ngFor="let item of breadcrumb; let i = index">
      <a [routerLink]="item.uri" *ngIf="item.uri; else active">{{item.title}}</a>
      <ng-template #active>{{item.title}}</ng-template>
    </li>
  </ol>
</nav>
